module.exports = __webpack_public_path__ + "img/news_1.6700817c.png";